module.exports = __webpack_public_path__ + "img/avatar-s-24.4478202c.jpg";